import { render } from "./page-dsp.vue?vue&type=template&id=48f4b86b"
import script from "./page-dsp.js?vue&type=script&lang=js"
export * from "./page-dsp.js?vue&type=script&lang=js"

import "./page-dsp.vue?vue&type=style&index=0&id=48f4b86b&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__